<template>
  <div id="app">
    <div v-if="user && firebaseLoaded" class="app__container" id="app__container" :class="{navMinimized: navMinimized}">
      <nav v-if="!navMinimized" id="nav">
        <div class="brand">
          <img src="@/assets/logo.svg" alt="Hyphen-Hacks logo">
          <h1 class="heading">Hyphen-Hacks 2020</h1>
        </div>
        <div class="scroll">
          <router-link class="nav__link" :class="{active: $route.path == '/'}" to="/"><i class="fas fa-chart-line"></i> Statistics</router-link>
          <router-link class="nav__link" :class="{active: $route.path == '/review'}" to="/review"><i class="fas fa-stream"></i> Applications in review
            <span class="notification" v-if="$store.getters.applications.length > 0"><i class="fas fa-bell"></i>{{$store.getters.applications.length}}</span>
          </router-link>
          <router-link class="nav__link" :class="{active: $route.path == '/roster'}" to="/roster"><i class="fas fa-clipboard"></i> Roster
          </router-link>
          <router-link class="nav__link" :class="{active: $route.path == '/mentors'}" to="/mentors"><i class="fas fa-chalkboard-teacher"></i> Mentors</router-link>
          <router-link class="nav__link" :class="{active: $route.path == '/attendees'}" to="/attendees"><i class="fas fa-user-graduate"></i> Attendees
          </router-link>
          <router-link class="nav__link" :class="{active: $route.path == '/volunteers'}" to="/volunteers"><i class="fas fa-hands-helping"></i>Volunteers
          </router-link>
          <router-link class="nav__link" :class="{active: $route.path == '/announcements'}" to="/announcements">
            <i class="fas fa-bell"> </i> Announcements
          </router-link>
          <router-link class="nav__link" :class="{active: $route.path == '/schedule'}" to="/schedule"><i class="fas fa-calendar-week"></i> Schedule


          </router-link>
        </div>


        <div class="nav__user">
          <p class="bold">{{user.displayName}}</p>
          <p>{{user.email}}</p>
          <button @click="logOut" class="btn--dark">Logout</button>
        </div>
        <p class="nav__link" @click="navMinimized = true"> <i class="fas fa-chevron-left "></i> Minimize</p>
      </nav>
      <nav v-if="navMinimized" id="nav">
        <div class="brand">
          <img src="@/assets/logo.svg" alt="Hyphen-Hacks logo">
        </div>
        <div class="scroll">
        <router-link class="nav__link" :class="{active: $route.path == '/'}" to="/"><i class="fas fa-chart-line"></i></router-link>
        <router-link class="nav__link" :class="{active: $route.path == '/review'}"  to="/review"><i class="fas fa-stream"></i>

        </router-link>
        <router-link class="nav__link" :class="{active: $route.path == '/roster'}" to="/roster"><i class="fas fa-clipboard"></i>
        </router-link>
        <router-link class="nav__link" :class="{active: $route.path == '/mentors'}" to="/mentors"><i class="fas fa-chalkboard-teacher"></i></router-link>
        <router-link class="nav__link" :class="{active: $route.path == '/attendees'}" to="/attendees"><i class="fas fa-user-graduate"></i>
        </router-link>
        <router-link class="nav__link" :class="{active: $route.path == '/volunteers'}" to="/volunteers"><i class="fas fa-hands-helping"></i>
        </router-link>
        <router-link class="nav__link" :class="{active: $route.path == '/announcements'}" to="/notifications">
          <i class="fas fa-bell"> </i>
        </router-link>
        <router-link class="nav__link" :class="{active: $route.path == '/schedule'}" to="/schedule"><i class="fas fa-calendar-week"></i>
        </router-link>
        </div>
        <i class="fas fa-chevron-right btn--clear  mt-auto" @click="navMinimized = false"></i>
      </nav>
      <router-view/>
    </div>
    <div v-if="!user && firebaseLoaded" class="app__container" id="login">
      <div class="card">
        <h1 class="heading">Login</h1>
        <p>Please login to access the Hyphen-Hacks 2020 Admin Dashboard</p>
        <p>For security reasons, please use your Hyphen-Hacks email address. If you need help signing in please email
          Ronan
          <a href="mailto:ronan.furuta@hyphen-hacks.com">ronan.furuta@hyphen-hacks.com</a></p>
        <p>Non Hyphen-Hacks team members need to be authorized manually, please email <a
            href="mailto:ronan.furuta@hyphen-hacks.com">Ronan</a> from the email you would like authorized. (this can
          take up to 24 hours)</p>
        <button @click="login" class="btn mt-1"><i class="fa fa-google"></i>Login With Google</button>
      </div>

    </div>
    <div v-if="!firebaseLoaded" class="loader--full">
      <div class="loader__row"></div>
      <div class="loader__row">
        <Loader></Loader>
        <h1 class="heading">Hyphen-Hacks 2020 Dashboard</h1>
        <h2>Dashboard v{{version}}</h2>
      </div>
      <div class="loader__row">

        <p>Something not working right? Get tech support <a href="mailto:ronan.furuta@hyphen-hacks.com">ronan.furuta@hyphen-hacks.com</a>
        </p>
      </div>

    </div>

  </div>
</template>
<script>
  import Loader from "./components/Loader"
  let focus, blur, tokenRefresh
  export default {
    name: "AppContainer",
    components: {Loader},
    data() {
      return {
        version: require("../package").version,
        firebaseLoaded: false,
        noAccess: false,
        navMinimized: false
      }
    },
    computed: {
      user() {
        return this.$store.getters.user
      }
    },
    methods: {

      loadBasicData() {
        if (this.$route.path != "/review") {
          fetch(this.$store.getters.api + "/api/v1/admin/applications", {
            method: "get",
            headers: {
              "Authorization": this.$store.getters.token
            }
          }).then(async res => {
            let json = await res.json()
            console.log(json, res.status)
            if (json.applicants) {
              this.$store.commit("applications", json.applicants)
            }
          })
        }

      },
      login() {
        var provider = new this.$firebase.auth.GoogleAuthProvider();
        provider.setCustomParameters({
          'login_hint': 'user@hyphen-hacks.com'
        });
        this.$firebase.auth().signInWithRedirect(provider);
      },
      logOut() {
        this.$firebase.auth().signOut()
      }
    },
    mounted() {
      let verifyEmail = async () => {
        try {
          let res = await fetch(this.$store.getters.api + "/api/v1/admin/auth/verifyemail", {
            method: "get",
            headers: {
              "authorization": this.$store.getters.token,
            }
          }).catch(() => {
            return false
          })
          if (res) {
          //  console.log(res, "response")
            let jsonRes = await res.json()
            //console.log(jsonRes, res, "json wresponse")
            return jsonRes.success
          } else {
            return false
          }

        } catch {
          return false
        }


      }
      let getToken = (trig) => {
        console.log('token trigger', trig)
        if (this.$firebase.auth().currentUser) {
          this.$firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then((idToken) => {

            this.$store.commit("token", idToken)

          })
        } else {

        }

      }
      this.$firebase.auth().onAuthStateChanged((user) => {

        if (user) {
          // User is signed in.
          let email = user.email
          console.log(email.endsWith("hyphen-hacks.com"))

          this.$firebase.auth().currentUser.getIdToken(/* forceRefresh */ true).then(async (idToken) => {
            // Send token to your backend via HTTPS
            // ...
            this.$store.commit("token", idToken)
            if (await verifyEmail() === true) {
              this.$store.commit("user", user)

              this.firebaseLoaded = true
              tokenRefresh = window.setInterval(function () {
                getToken("interval")
              }, 900000)
              focus = window.addEventListener("focus", function () {
                getToken("focus")
              }, false);

              this.loadBasicData()


            } else {
              this.$store.commit("user", false)
              this.firebaseLoaded = true
              this.noAccess = true
              console.log("no acess")
              this.$swal({
                title: "No Access",
                text: "Please login with your @Hyphen-Hacks email address",
                icon: "error"
              })
            }
          }).catch(function (error) {
            // Handle error
          });
        } else {
          this.$store.commit("user", false)
          this.firebaseLoaded = true
          // No user is signed in.
        }
      });
    }
  }
</script>

